export default __webpack_public_path__ + "static/Gilroy-RegularItalic-5274d57ffc34303e3fcdd7d8b6659759.woff2";